import { render, staticRenderFns } from "./smsTemplate.vue?vue&type=template&id=85aff372&scoped=true"
import script from "./smsTemplate.vue?vue&type=script&lang=js"
export * from "./smsTemplate.vue?vue&type=script&lang=js"
import style0 from "./smsTemplate.vue?vue&type=style&index=0&id=85aff372&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85aff372",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85aff372')) {
      api.createRecord('85aff372', component.options)
    } else {
      api.reload('85aff372', component.options)
    }
    module.hot.accept("./smsTemplate.vue?vue&type=template&id=85aff372&scoped=true", function () {
      api.rerender('85aff372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/smsConfiguration/cmp/smsTemplate.vue"
export default component.exports